import React, { Component } from 'react';
export default class ChildCompany extends Component {
  constructor(props) {
    super(props)
    this.state = {
      block: [
        // {
        //   title: '工程财务咨询事业部',
        //   content: '工程财务咨询事业部聚集了一批以工程财务专业为主，工程造价、工程咨询、税务、管理等多专业融合的团队，熟练掌握工程管理与财务管理相关的法律法规，并形成了一套系统的业务规范体系，专职于为工程建设项目提供工程竣工财务决算编制、工程竣工财务决算审计、征地拆迁专项审计、建设期经济责任审计等财务咨询与审计服务。'
        // },
        {
          title: '青矩标准研究院',
          content: '青矩标准研究院是青矩工程咨询标准研究与集团化运营管理机构，围绕全过程工程咨询产品线，开展标准化、信息化、数据化、智能化研究，赋能员工并实施品质管控，使工程咨询服务更精准、更高效、更有价值。青矩标准研究院下设管理办公室、品控中心、造价管理分院、招采管理分院、数据标准分院。'
        },
        // {
        //   title: '工程投资咨询(PPP)事业部',
        //   content: '工程投资咨询（PPP）事业部由众多高级工程师、高级会计师、咨询工程师、注册税务师、资产评估师、律师等专业技术人员组成，有着丰富的建设项目工程咨询、PPP项目咨询、项目投融资咨询的执业经验。利用工程、财务、税务等专业能力，可为客户提供全过程的PPP项目咨询、项目前期咨询及咨询评估等服务。应用体系。'
        // },
        // {
        //   title: 'BIM 咨询事业部',
        //   content: 'BIM应用咨询事业部致力为建设项目提供方案比选、设计优化、招投标、施工模拟、过程控制、运营维护等全生命周期BIM咨询服务。迄今为止利用天职BIM云平台已为房屋建筑、轨道交通、能源化工、高速公路等多个领域的大型项目提供了全面、专业、优质的BIM咨询服务。'
        // },
        // {
        //   title: '工程管理技术培训事业部',
        //   content: '工程管理技术培训事业部聚焦建筑工程管理与工程技术，依托天职咨询各业务板块丰富的实操经验及专业积累，对接国内最优秀的专家与师资团队，为工程管理领域各层级人士提供专业岗位技能、职业能力提升、高端人才管理实践等培训，助力学员成为行业的专家、管理的精英。'
        // },
        {
          title: '青矩科技研究院',
          content: '青矩科技研究院是青矩工程科技研究机构，主要围绕工程咨询项目管理技术的研发和实现，从BIM 技术、智慧智能、工程大数据、信息管理系统等方面，开展具有自主知识产权、安全可控的插件、工具、系统、平台的创新研发和落地，为工程科技赋能。青矩科技研究院下设管理办公室、BIM分院、大数据分院、智能作业分院、行业信息化分院及IT咨询中心。'
        },
        // {
        //   title: '国际业务部',
        //   content: '天职咨询国际业务团队由海外留学归国精英和经验丰富的国际工程建设者组成。他们精通国内外工程管理模式、工程造价管控与计价体系，了解国际政治经济形势，熟悉世界各国的法律、语言和风俗，能为国际工程建设项目提供全方位的工程咨询与审计服务。'
        // },
      ]
    }
  }
  render() {
    return (
      <div className="bussiness-container">
        <p className="ecology-title">研究机构</p>
        {/* <div className="details">
          围绕全过程工程咨询，天职咨询组建了工程财务咨询、工程管理咨询、工程投资咨询、BIM应用咨询、工程管理技术培训、大数据、国际业务等7个事业部，为客户提供更加专业的细分服务。这些事业部互相支撑、相互转换，形成一个整体的生态。
        </div> */}
        {
          this.state.block.map((item, index) =>
            <div className="bussiness-block" key={index}>
              <span className={'icon0' + (index + 1)}></span>
              <div className="right-block">
                <p className="sub-title">{item.title}</p>
                <div className="sub-box">
                  {item.content}
                </div>
              </div>
            </div>
          )
        }
      </div>
    )
  }
}
